module.exports = __webpack_public_path__ + "static/img/cjfw-logo.47974fe0.png";